var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-field',{attrs:{"disabled":_vm.disabled,"label":_vm.label,"placeholder":_vm.placeholder || _vm.label,"required":_vm.required,"rules":_vm.rules,"readonly":_vm.readonly,"clearable":_vm.clearable},on:{"input":_vm.change,"focus":_vm.focus},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2467c237","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseInput.vue
// module id = null
// module chunks = 